/**
 * The two CAM worlds the shop runs side by side.
 *
 * `legacy` is the CATIA-era tool catalog the historic programs were written against;
 * `hypermill` is the one exported from hyperMILL for the new process. Tools, holders,
 * assemblies, rule sets and projects each belong to exactly one, and nothing crosses over:
 * a project may only call the assemblies of its own system. Mirrors backend `ToolSystem`.
 */
export const TOOL_SYSTEMS = ['legacy', 'hypermill'] as const;

export type ToolSystem = (typeof TOOL_SYSTEMS)[number];

/**
 * The system the app opens in before anyone has picked one.
 *
 * hyperMILL, because that is the catalog the new process is programmed against — `legacy` is
 * there to read the historic programs, not to start from. Deliberately *not* the backend's
 * `DEFAULT_TOOL_SYSTEM`, which is `legacy` and answers a different question: what a record
 * that never stated a system was machined with. Nothing here relies on the two agreeing.
 */
export const INITIAL_TOOL_SYSTEM: ToolSystem = 'hypermill';

/** Translation key of a system's label, e.g. `toolSystem.legacy`. */
export function toolSystemLabelKey(system: ToolSystem): string {
  return `toolSystem.${system}`;
}

export function isToolSystem(value: unknown): value is ToolSystem {
  return typeof value === 'string' && (TOOL_SYSTEMS as readonly string[]).includes(value);
}
